import { SignOut, Trash, UserCircle } from '@phosphor-icons/react';
import { Modal } from './Modal';

interface AccountModalProps {
  open: boolean;
  name: string;
  email: string;
  loading?: boolean;
  onClose: () => void;
  onLogout: () => void;
  onDeleteAccount: () => void;
}

export function AccountModal({
  open,
  name,
  email,
  loading = false,
  onClose,
  onLogout,
  onDeleteAccount,
}: AccountModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="계정"
      description="클라우드 저장과 공유에 사용 중인 계정입니다."
      className="account-modal"
    >
      <div className="account-profile">
        <UserCircle size={40} weight="fill" aria-hidden="true" />
        <div>
          <strong>{name}</strong>
          <span>{email}</span>
        </div>
      </div>
      <div className="account-actions">
        <button className="button button-secondary button-block" type="button" disabled={loading} onClick={onLogout}>
          <SignOut size={17} />
          로그아웃
        </button>
        <button className="button button-block account-delete" type="button" disabled={loading} onClick={onDeleteAccount}>
          <Trash size={17} />
          회원탈퇴
        </button>
      </div>
    </Modal>
  );
}
